import { Route } from '@angular/router';
import { DirectorsListComponent } from './ui/directors-list/directors-list.component';

const directorsRoutes: Route[] = [
    {
        path: 'directors',
        component: DirectorsListComponent,
    },
];

export default directorsRoutes;
